module.exports = __webpack_public_path__ + "static/media/home-landing-bg.ed5e289b.jpg";